<template>
    <bollo />
  </template>
  
  <script>
  import Bollo from '@/components/ask/pages/tesoreria/Bollo.vue'
  
  export default {
    name: 'PageTesoreriaBollo',
  
    components:{
      Bollo
    },
  
    data(){
      return {
      
      }
    },
  
    created(){
      
    },
  
    mounted(){
    //   this.$eventBus.emit('page-change', {
    //     target: this,
    //     currentRoute: this.$router.currentRoute.value
    //   })
    },
  
    methods:{
  
    },
  }
  </script>
  
  <style>
  
  </style>
  